import {EnumParaOrg} from '../../core/models/enum/enum-parametros';
import {ClsParametro} from "../../core/models/cls-parametros";

export class ClsObjParametrosPorOrganizacion {
  constructor() {
  }

  public getParametrosDefaultsOrg(): ClsParametro[] {
    return [
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaOrg.TIPOCONCEPTO,
        Valor: '4',
        Descripcion: 'Tipo predeterminado para conceptos'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaOrg.TIPOMATRIZ,
        Valor: '1',
        Descripcion: 'Tipo predeterminado para matrices'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaOrg.UNIINSESPRES,
        Valor: 'HOR',
        Descripcion: 'Unidad insumo en espera y reserva'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaOrg.UNIINSLLANTAS,
        Valor: 'JGO',
        Descripcion: 'Unidad insumo de llantas'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaOrg.UNIINSPZAESP,
        Valor: 'JGO',
        Descripcion: 'Unidad insumo de piezas especiales'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaOrg.UNIINSCOMBUSTIBLEEQ,
        Valor: 'LT',
        Descripcion: 'Unidad insumo combustible del equipo'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaOrg.UNIINSLUBEQ,
        Valor: 'LT',
        Descripcion: 'Unidad insumo lubricante del equipo'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaOrg.UNIVALORADQEQ,
        Valor: 'PZA',
        Descripcion: 'Unidad valor de adquisición del equipo'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaOrg.UNIPOTENCIACH,
        Valor: 'HP',
        Descripcion: 'Unidad potencia en Costo Horarios'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaOrg.LOGO,
        Valor: 'neodata.png',
        Descripcion: 'Logo para reportes'
      },
      {
        IdParametro: BigInt('0'),
        Llave: BigInt('0'),
        Parametro: EnumParaOrg.NUMCODCONSECUTIVO,
        Valor: '16',
        Descripcion: 'Número de caracteres para código consecutivo'
      }
    ];
  }

  public getParametrosOpcionesGrals(): ClsParametro[] {
    return [
      {
        Parametro: EnumParaOrg.TIPOCONCEPTO
      },
      {
        Parametro: EnumParaOrg.TIPOMATRIZ
      },
      {
        Parametro: EnumParaOrg.UNIINSESPRES
      },
      {
        Parametro: EnumParaOrg.UNIINSLLANTAS
      },
      {
        Parametro: EnumParaOrg.UNIINSPZAESP
      },
      {
        Parametro: EnumParaOrg.UNIINSCOMBUSTIBLEEQ
      },
      {
        Parametro: EnumParaOrg.UNIINSLUBEQ
      },
      {
        Parametro: EnumParaOrg.UNIVALORADQEQ
      },
      {
        Parametro: EnumParaOrg.UNIPOTENCIACH
      },
      {
        Parametro: EnumParaOrg.LOGO
      },
      {
        Parametro: EnumParaOrg.NUMCODCONSECUTIVO
      },
      {
        Parametro: EnumParaOrg.SOLOADMINVERCORREOSORG
      }
    ];
  }

  public getParametrosCH(): ClsParametro[] {
    return [
      {
        Parametro: EnumParaOrg.UNIINSESPRES,
        Valor: 'HOR'
      },
      {
        Parametro: EnumParaOrg.UNIINSLLANTAS,
        Valor: 'JGO'
      },
      {
        Parametro: EnumParaOrg.UNIINSPZAESP,
        Valor: 'JGO'
      },
      {
        Parametro: EnumParaOrg.UNIINSCOMBUSTIBLEEQ,
        Valor: 'LT'
      },
      {
        Parametro: EnumParaOrg.UNIINSLUBEQ,
        Valor: 'LT'
      },
      {
        Parametro: EnumParaOrg.UNIVALORADQEQ,
        Valor: 'PZA'
      },
      {
        Parametro: EnumParaOrg.UNIPOTENCIACH,
        Valor: 'HP'
      },
    ];
  }
}
